'use strict';

/* eslint-env browser */

function getExpiry(days) {
  const date = new Date();

  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  return `expires=${date.toUTCString()};`;
}

exports.getItem = key => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);

  if (parts.length !== 2) {
    return null;
  }

  return parts.pop().split(';').shift();
};

exports.setItem = (key, value, days = false) => {
  const { hostname } = window.location;

  let cookie = `${key}=${value};`;

  if (days) {
    cookie += getExpiry(days);
  }

  cookie += `domain=${hostname};`;

  document.cookie = cookie;
};
